/* eslint-disable react/jsx-props-no-spreading */

import Link from 'next/link';
import { ICategory, TServiceMap } from '@features/categories';
import styles from '@features/navigation/components/MegaMenuDesktop/MegaMenuDesktop.styles';
import { TImage } from '@components/typescript';
import MenuLabels from '@components/MenuLabels/MenuLabels';
import { NAVIGATION__PRODUCT_NAME_MAX_COUNT } from '@features/navigation/const';
type PropsType = {
  product: ICategory;
  serviceMap: TServiceMap;
  onCloseMenu: () => void;
  onHoverItem?: (file: TImage) => void;
  selectedProduct: number;
  setSelectedProduct: (product: number) => void;
  isMobile: boolean;
};
const ProductsItem = ({
  product,
  serviceMap,
  onCloseMenu,
  onHoverItem = undefined,
  selectedProduct,
  setSelectedProduct,
  isMobile
}: PropsType) => {
  const getItemLink = () => {
    if (product?.behaviour === 'external_link') {
      if (!product?.external_link?.length) return null;
      return product?.external_link;
    }
    return `/${serviceMap[product.id]}`;
  };
  const handleHover = () => {
    const newImage = product.files ? product.files.filter(img => img.type === 'CATEGORY_MENU') : [];
    if (newImage.length && onHoverItem) {
      onHoverItem(newImage[0]);
    }
    setSelectedProduct(product.id);
  };
  const hoverEvents = isMobile ? {} : {
    onMouseEnter: handleHover
  };
  const haveLabel = product.is_new || product.personalization || product.promo;
  if (product?.behaviour === 'hidden' || !getItemLink()) return null;
  return <li key={product.id} sx={styles.productItemContainer(true)}>
      <Link href={getItemLink() || '#'} prefetch={false} sx={styles.productItemLink(product.name.length > NAVIGATION__PRODUCT_NAME_MAX_COUNT, haveLabel)} {...hoverEvents} onClick={onCloseMenu} className="nav_menu-lvl-three">
        <span data-cy={`MarketingProductsSubtype-${product.slug}`}>
          <span sx={styles.productActive(product.id === selectedProduct)}>{product.name}</span>
        </span>
      </Link>
      {haveLabel && <MenuLabels isNew={product.is_new} isPersonalization={product.personalization} isPromo={product.promo} />}
    </li>;
};
export default ProductsItem;